export default __webpack_public_path__ + "static/media/close_icon.42159171.svg";